import PropTypes from 'prop-types';
import React from 'react';
import { DirectionContextProvider } from './DirectionContext';
import cookieManagerHelper from 'Helpers/cookies';

export class DirectionProvider extends React.Component {
    static propTypes = {
        children: PropTypes.any,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        })
    };

    constructor(props) {
        super(props);
        this.direction = this.getDirection() || 'ltr';
    }

    getDirection() {
        const currentLang = cookieManagerHelper.readCookie('lang') || this.props.config.get('langs')[0].code;
        const langConfig = this.props.config.get('langs').find(({ code }) => code === currentLang);

        return langConfig && langConfig.dir;
    }

    render() {
        const value = {
            direction: this.direction
        };

        return (
            <DirectionContextProvider value={ value }>
                { this.props.children }
            </DirectionContextProvider>
        );
    }
}

export default DirectionProvider;
